<template>
    <popup v-if="usageDialogActive" @close="hideUsageDialog()" title="Kurzanleitung" class="instPopup">
        <div>
            <div class="w-100"><p class="title-medium">Willkommen beim Education Cloud Konfigurator für das digitale Klassenzimmer. Gleich kann es losgehen!</p></div>
            <transition name="fade" mode="out-in">
                <div class="w-100 instruction">
                    <p class="title-thin clearfix"><span class="number">{{ instruction_number[currentPage] }}</span><span v-html="instruction[currentPage]"></span></p>
                    <img :src="require(`@/assets/${instruction_image[currentPage]}`)" alt="">
                    <button class="button" v-if="currentPage < 5" @click="setPage(currentPage + 1)">Weiter</button>
                    <button class="button" v-if="currentPage >= 5" @click="hideUsageDialog()">Legen Sie los</button>
                </div>
            </transition>
        </div>
    </popup>
</template>

<script>
    import popup from './Popup.vue'

    export default {
        components: {
            popup
        },
        data(){
            return {
                currentPage: 1,
                usageDialogActive: true,
                instruction: {
                    1: "Was möchten Sie in einem modernen Klassenzimmer machen?<br>Klicken Sie links auf Ihre gewünschte Funktion.",
                    2: "Nach der Auswahl erhalten Sie eine kurze Beschreibung über die gewählte Funktion. Sie können durch Anklicken «Pädagogischer Nutzen» weiterführende Informationen erhalten für den konkreten Einsatz im Schulunterricht.",
                    3: "<ol><li>Durch «Hinzufügen» wird Ihre ausgewählte Funktion in das Klassenzimmer integriert.</li><li>Durch erneutes Anklicken der Funktion in der Liste haben Sie auch immer die Möglichkeit die Funktion zu entfernen.</li></ol>",
                    4: "Wählen Sie weitere Funktionen aus.",
                    5: "Haben Sie alles? Gehen Sie weiter zur Zusammenfassung."
                },
                instruction_image: {
                    1: "instruction1.jpg",
                    2: "instruction2.jpg",
                    3: "instruction3.jpg",
                    4: "instruction4.jpg",
                    5: "instruction5.jpg",
                },
                instruction_number: {
                    1: "I.",
                    2: "II.",
                    3: "III.",
                    4: "IV.",
                    5: "V.",
                }
            }
        },
        methods: {
            setPage(page){
                this.currentPage = page
            },
            showUsageDialog(){
                this.usageDialogActive = true
            },
            hideUsageDialog(){
                this.usageDialogActive = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .instruction {
        .button {
            margin: 0 auto;
            width: 200px;
            text-align: center;
            display: block;
        }
        span {
            display: block;
            float: left;
            width: calc(100% - 80px);
        }
        .number {
            font-size: 62px;
            height: 100%;
            margin: 0 10px;
            line-height: 32px;
            width: 48px;
        }
        .title-thin {
            font-size: 24px;
            margin: 60px 0;
        }
        img {
            width: 80%;
            margin: 20px auto 60px auto;
            text-align: center;
            display: block;
        }
    }
</style>
